import type {Headers} from '@sail/data';

const STRIPE_VERSION_HEADER = 'Stripe-Version';
const AUTHORIZATION_HEADER = 'Authorization';

export default function addHttpHeaders(
  headers: Headers,
  schemaVersion: string,
  endpoint: string,
) {
  headers.set('Content-Type', 'application/json');
  headers.set('X-Requested-With', 'XMLHttpRequest');

  // GraphiQL manually overrides the version in some cases. If they do, use it.
  const versionToUse = headers.get(STRIPE_VERSION_HEADER) ?? schemaVersion;

  if (endpoint !== '/ajax/graphql') {
    headers.set(STRIPE_VERSION_HEADER, versionToUse);
  } else {
    // Remove this once we can stop routing requests through manage-srv on devbox. Ideally
    // we'd route directly to edge but that's blocked.  See this doc:
    // https://docs.google.com/document/d/1Yrwb4o-8kGETmprZO8fFG2f9hACvjQshaH5rtoAXj5Y/edit#
    headers.set('X-Temp-V2-Version', versionToUse);
  }

  if (!headers.get(AUTHORIZATION_HEADER)) {
    headers.set(AUTHORIZATION_HEADER, 'STRIPE-V2-SIG');
  }
}
